import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EduNetApi } from '../+api';
import { EduNetInterface } from '../+models';
import { EduNetServiceInterface } from './edu-net.service.interface';

@Injectable({
  providedIn: 'root',
})
export class EduNetService implements EduNetServiceInterface {
  private eduNetApi = inject(EduNetApi);

  getAll(): Observable<EduNetInterface[]> {
    return this.eduNetApi.find();
  }

  getEduNets$(
    searchTerm?: string,
    filters?: { [key: string]: string | number[] | number },
    pagination?: { from?: any; amount?: any },
    columns?: string[],
    sorting?: { [key: string]: 'asc' | 'desc' }
  ): Observable<{ results: EduNetInterface[]; count: number }> {
    const params = new HttpParams({
      fromObject: {
        searchTerm: searchTerm || '',
        filters: JSON.stringify(filters || {}),
        columns: JSON.stringify(columns || null),
        sorting: JSON.stringify(sorting || {}),
        pagination: JSON.stringify(pagination || {}),
      },
    });
    return this.eduNetApi.getEduNets(params);
  }

  public deleteEduNetById(id: number): Observable<boolean> {
    return this.eduNetApi.deleteEduNetById(id);
  }

  public create(eduNet: EduNetInterface): Observable<EduNetInterface> {
    return this.eduNetApi.create(eduNet);
  }

  public update(eduNet: EduNetInterface): Observable<EduNetInterface> {
    const params = new HttpParams({
      fromObject: {
        id: eduNet.id?.toString(),
      },
    });
    return this.eduNetApi.update(params, eduNet);
  }
}
